// Port of api/fuel/app/classes/filter/package/games/play/data/players.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	require: function(config, filter) { return !filter.play || !filter.play.group },
	run: function(filter, data, config, global) {
		global.players = global.players || { plays: {}, exist: {} }
		if (!global.resultIndex || !global.resultIndex.length) return
		var rows = DB.query('SELECT * FROM player WHERE play_id IN(' + Util.in(global.resultIndex) + ')')
		for (var i = 0; i < rows.length; i++) {
			var r = rows[i]
			if (!global.players.plays[r.play_id]) global.players.plays[r.play_id] = []
			global.players.plays[r.play_id].push(r)
			if (r.user_id) global.players.exist[r.user_id] = true
		}
	}
}
